import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { categoriesAPI } from '../lib/api';
import { getCategoryImage } from '../lib/utils';
import { ArrowRight } from 'lucide-react';

const CategoriesPage = () => {
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await categoriesAPI.getAll();
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="min-h-screen py-12" data-testid="categories-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <p className="text-sm text-orange-600 font-medium tracking-wide uppercase mb-2">Explorer</p>
          <h1 className="text-4xl md:text-5xl text-slate-900" style={{ fontFamily: '"DM Serif Display", serif' }}>
            Toutes les catégories
          </h1>
          <p className="text-lg text-slate-600 mt-4 max-w-2xl">
            Découvrez plus de 50 métiers dans 8 catégories différentes. Trouvez le professionnel parfait pour vos besoins.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="h-64 rounded-xl skeleton-loading"></div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {Object.entries(categories).map(([key, category], index) => (
              <Link
                key={key}
                to={`/search?category=${key}`}
                className="group block animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'backwards' }}
                data-testid={`category-${key}`}
              >
                <div className="relative overflow-hidden rounded-xl card-hover">
                  <div className="aspect-[16/9] relative">
                    <img
                      src={getCategoryImage(key)}
                      alt={category.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent"></div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h2 className="text-2xl text-white mb-2" style={{ fontFamily: '"DM Serif Display", serif' }}>
                      {category.name}
                    </h2>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {category.trades.slice(0, 4).map((trade) => (
                        <span key={trade} className="px-3 py-1 rounded-full bg-white/20 text-white/90 text-xs backdrop-blur-sm">
                          {trade}
                        </span>
                      ))}
                      {category.trades.length > 4 && (
                        <span className="px-3 py-1 rounded-full bg-white/20 text-white/90 text-xs backdrop-blur-sm">
                          +{category.trades.length - 4} autres
                        </span>
                      )}
                    </div>
                    <div className="flex items-center text-white/80 text-sm group-hover:text-white transition-colors">
                      Voir les {category.trades.length} métiers
                      <ArrowRight className="h-4 w-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriesPage;
